import React, {useState, useEffect} from 'react';
import {InputSaveBtn,InputText} from 'admin/components';
import {LoadingList} from 'components/items';
import {alertDone} from 'function/alert';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
var db = firebase.firestore();

const COLLECTION = "about";
const DOC = "video";

const AboutVideo = () => {
  const [dataVideo, setDataVideo] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=> {
    _get();
  },[])

  useEffect(()=> {
    if(dataVideo){
      setIsLoading(false);
    }
  }, [dataVideo])

  // - method - 
  // get from firebase
  const _get = () => {
    setIsLoading(true);
    db.collection(COLLECTION).doc(DOC).get().then((querySnapshot) => {
      setDataVideo(querySnapshot.data());
    });
  }

  // when video link input change
  const onInputChange = (e) => {
    const textTemp = e.target.value;
    setDataVideo({
      ...dataVideo,
      value: textTemp
    })
  }

  const onSubmitClick = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    await updateData();

    setIsLoading(false);
    alertDone();
  }

  const updateData = async () => {
    const ref = await db.collection(COLLECTION).doc(DOC);
    try{
      await ref.set(dataVideo)
    }
    catch(err){
      console.log(err)
    }
      
  }

  const drawForm = () => {
    return  <form onSubmit={onSubmitClick}>
              <InputText
                label = {dataVideo.label}
                name = {dataVideo.name}
                value = {dataVideo.value}
                placeholder = {dataVideo.placeholder} 
                onChange = {onInputChange}/>
              
              <div className="video-container">
                <iframe
                  className ="iframe-youtube"
                  src={dataVideo.value} 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                  title = "about video"
                >

                </iframe>
              </div>

              <InputSaveBtn text="저장" className="border"/>
            
            </form>
  }
  
  return (
    <section className="AboutVideo lnbSectionn">

      <div className={`${isLoading ? "" : "hide"} wrap-inner-loading`}>
        <LoadingList />
      </div>

      {dataVideo 
      ? drawForm()
      : ""}

    </section>
  );
}

export default AboutVideo;